import { Timestamp } from '@bufbuild/protobuf/wkt';
import { ListKPIsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { simulationsClient } from '../simulations-client';
import { aqoraClient } from '../aqora-client';

export const listSimulationKpisDashboard = async ({
  simulationId,
  resourceName,
  rangeFrom,
  rangeTo,
}: {
  simulationId: string;
  resourceName: string;
  rangeFrom: Timestamp;
  rangeTo: Timestamp;
}): Promise<ListKPIsResponse> =>
  simulationsClient.listSimulationKPIs({
    runAttemptName: simulationId,
    resourceName,
    rangeFrom,
    rangeTo,
  });

export const listKpisDashboard = async ({
  resourceName,
  rangeFrom,
  rangeTo,
}: {
  resourceName: string;
  rangeFrom: Timestamp;
  rangeTo: Timestamp;
}): Promise<ListKPIsResponse> => {
  const data = await aqoraClient.listKPIs({ resourceName, rangeFrom, rangeTo });

  return data;
};
